import React from 'react';
import { cn } from '../../utils/cn';

const badgeVariants = {
  variant: {
    default: 'badge-default',
    primary: 'badge-primary',
    secondary: 'badge-secondary',
    success: 'badge-success',
    warning: 'badge-warning',
    error: 'badge-error',
    outline: 'border border-gray-300 bg-transparent text-gray-700',
  },
  size: {
    sm: 'badge-sm',
    md: 'badge-md',
    lg: 'badge-lg',
  },
};

const Badge = React.forwardRef(({
  className,
  variant = 'default',
  size = 'md',
  ...props
}, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'badge',
        badgeVariants.variant[variant],
        badgeVariants.size[size],
        className
      )}
      {...props}
    />
  );
});

Badge.displayName = 'Badge';

export default Badge;